import { CLEAR_PIPELINE_FILTERS, SET_PIPELINE_FILTERS } from './types'

export const setPipelineFilters = (filters: Record<string, any>) => ({
  type: SET_PIPELINE_FILTERS,
  payload: filters,
})

export const clearPipelineFilters = () => ({
  type: CLEAR_PIPELINE_FILTERS,
})
